export default {
    about: " deals with an online system designed for booking cabs as per the requirements of the customers at their convenience. The current system is manual and it is time-consuming. It is also cost-ineffective, and the average return is low and diminishing. We give customer satisfaction the utmost priority and so give ample options to book cab by entering details like their journey date and time, origin, pick-up point, destination and the drop-off point they need to reach",
    features: [
        "Book Cabs instantly",
        "Vehicles Gallary ",
        "Pricing List for various places",
        "Google Places Integration",
        "Mobile-Friendly & Responsive Website",
        "Ease Of Use"
    ]

}
